import moment from "moment";
import status from "http-status";
import { createCrudActions } from "../utils/crudGenerator";
import { fetchAccounts } from "./accountsActions";

const formatDeposits = (data) => {
  if (!data) {
    return [];
  }
  const formatItem = (item) => ({
    ...item,
    label: `${item.name}`,
    value: item._id,
    date: item.date && moment(item.date),
  });

  if (Array.isArray(data)) {
    return data.map(formatItem);
  }
  return formatItem(data);
};

const crudActions = createCrudActions("DEPOSIT", "Ingreso", formatDeposits);

export const { fetch: fetchDeposits } = crudActions;

const withAccountsRefresh =
  (actionCreator) =>
  (...args) =>
  async (dispatch) => {
    const response = await dispatch(actionCreator(...args));
    if (status[`${response}_CLASS`] === status.classes.SUCCESSFUL) {
      dispatch(fetchAccounts());
    }
    return response;
  };

export const createDeposit = withAccountsRefresh(crudActions.create);
export const updateDeposit = withAccountsRefresh(crudActions.update);
export const deleteDeposits = withAccountsRefresh(crudActions.delete);
